import {
    Button,
    Loading,
    Modal,
    ModalFooter,
    ModalHeader,
    useGetUserAccountsCountQuery,
    UserAccountActiveStatus,
} from "modules/common";
import { useEffect } from "react";
import { NotificationRecipientsFilter } from "services";

interface Props {
    isActive: boolean;
    selectedUsersCount: number;
    usersFilter: NotificationRecipientsFilter;
    onConfirm: () => void;
    toggleModal: () => void;
    openRecipientList: () => void;
}

export const SendNotificationConfirmationModal = ({
    isActive,
    selectedUsersCount,
    usersFilter,
    onConfirm,
    toggleModal,
    openRecipientList,
}: Props) => {
    const {
        data: count,
        isLoading: isLoadingRecipientsCount,
        refetch: refetchRecipientsCount,
    } = useGetUserAccountsCountQuery({ statusFilter: [UserAccountActiveStatus.Active], ...usersFilter }, false);

    useEffect(() => {
        if (isActive && selectedUsersCount === 0) refetchRecipientsCount();
    }, [isActive, refetchRecipientsCount, selectedUsersCount]);

    return (
        <Modal
            maintainWidth={30}
            isActive={isActive}
            modalHeader={<ModalHeader title="Slanje poruke" onClose={toggleModal} />}
            onClose={toggleModal}
            modalFooter={
                <ModalFooter>
                    <div className="f-r f-1 g-24 f-jc-sb">
                        <Button
                            type="button"
                            size="small"
                            variant="primary-ghost"
                            width="standard"
                            onClick={toggleModal}
                        >
                            ODUSTANI
                        </Button>

                        <Button
                            type="button"
                            size="small"
                            variant="primary"
                            width="standard"
                            onClick={() => {
                                onConfirm();
                                toggleModal();
                            }}
                        >
                            POŠALJI
                        </Button>
                    </div>
                </ModalFooter>
            }
        >
            <div className="send-notification-confirmation-modal">
                <span className="confirmation-text">
                    Jeste li sigurni da želite poslati poruku odabranoj listi primatelja?
                </span>
                <div className="f-r f-1 g-24 f-ai-c">
                    <div className="confirmation-count-text">
                        Broj primatelja:
                        <div>
                            {isLoadingRecipientsCount ? (
                                <Loading size="small" />
                            ) : (
                                selectedUsersCount || count
                            )}
                        </div>
                    </div>
                    <div>
                        <Button
                            size="small"
                            width="standard"
                            variant="primary-ghost"
                            onClick={openRecipientList}
                        >
                            LISTA PRIMATELJA
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
